const BANDANA_HATS = [
  {
    slug: "bandana-blue-6",
    name: "Bandana",
    description: "Fly your flag",
    rarity: "common",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 6
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "bandana-green-6",
    name: "Bandana",
    description: "Fly your flag",
    rarity: "common",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 6
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "bandana-orange-6",
    name: "Bandana",
    description: "Fly your flag",
    rarity: "common",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 6
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "bandana-pink-6",
    name: "Bandana",
    description: "Fly your flag",
    rarity: "common",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 6
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "bandana-purple-6",
    name: "Bandana",
    description: "Fly your flag",
    rarity: "common",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_purple",
      frameIndex: 6
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "bannanda-yellow-6",
    name: "Bannanda",
    description: "Come Mr. tallyman",
    rarity: "uncommon",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "goldColor",
        value: 10
      },
      {
        stat: "goldRes",
        value: 5
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_yellow",
      frameIndex: 6
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "bandana-red-6",
    name: "Bandana",
    description: "Fly your flag",
    rarity: "common",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "redRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 6
    },
    tags: ["daily-rotation"]
  }
];
export {
  BANDANA_HATS
};
//# sourceMappingURL=data:application/json;base64,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
